import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { ConfigContext } from './configContext.js';
export function ConfigProvider({ children }) {
    const [config, setConfig] = useState({});
    const [loadingInitial, setLoadingInitial] = useState(true);
    
    // An async effect returns a Promise where React expects a cleanup
    // function, and React calls it on unmount: "destroy is not a function".
    // Declare the async work inside and call it.
    useEffect(() => {
        let cancelled = false;

        async function loadConfig() {
            try {
                const response = await fetch('/conf/config.json');
                const data = await response.json();
                if (cancelled) return;

                setConfig({
                    ...data,
                    appTitle: (data?.viteAppTitle || '').replace(/\/$/, ''),
                    tabTitle: (data?.viteTabTitle || '').replace(/\/$/, ''),
                    apiUrl: (data?.apiUrl || '').replace(/\/$/, ''),
                    authMethod: (data?.authMethod || '').toLowerCase(),
                });
            } catch (err) {
                console.error('Failed to load config');
                console.error(err);
            } finally {
                if (!cancelled) setLoadingInitial(false);
            }
        }

        loadConfig();
        return () => {
            cancelled = true;
        };
    }, []);
    return (
        <ConfigContext.Provider value={config}>
          {!loadingInitial && children}
        </ConfigContext.Provider>
    );
}
ConfigProvider.propTypes = {
    children: PropTypes.node,
};

